<template>
    <div
        class="modal fade"
        id="registerFormModal"
        data-bs-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content tw-rounded-lg">
                <div class="modal-body" v-show="show_form">
                    <form
                        autocomplete="off"
                        @submit.prevent="onSubmit"
                        v-if="!phone_verification"
                    >
                        <div>
                            <h5>{{ __("chat.sign_up") }}</h5>
                            <button
                                type="button"
                                class="btn-close tw-opacity-100"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <hr />

                        <div class="row">
                            <div class="col-md-12 tw-mb-3">
                                <div
                                    class="tw-leading-none tw-mb-3 tw-bg-red-50 dark:tw-bg-slate-700 tw-rounded-lg tw-p-2 tw-py-3 tw-flex tw-items-center"
                                    v-if="error_message.length > 0"
                                >
                                    <i
                                        class="fas fa-exclamation-triangle tw-text-red-500 tw-text-md tw-ml-2 tw-mr-2"
                                    ></i>
                                    <span
                                        class="tw-text-sm tw-text-red-600"
                                        v-text="error_message"
                                    ></span>
                                </div>
                            </div>
                            <div class="col-md-12 tw-mb-3">
                                <div class="form-group">
                                    <label class="form-label tw-mb-1">{{
                                        __("chat.name")
                                    }}</label>
                                    <input
                                        name="name"
                                        type="text"
                                        class="form-control tw-py-3 tw-border-none tw-bg-slate-100 tw-rounded-lg"
                                        placeholder="Enter name"
                                        v-model="form.name"
                                        @focus="input_errors.name = ''"
                                    />
                                    <span
                                        class="tw-text-red-500 tw-text-xs"
                                        v-if="input_errors.name"
                                        v-text="input_errors.name[0]"
                                    ></span>
                                </div>
                            </div>
                            <div class="col-md-12 tw-mb-3">
                                <div
                                    v-show="form.register_type == 'phone'"
                                    class="form-group"
                                >
                                    <label class="form-label tw-mb-0">{{
                                        __("chat.phone_number")
                                    }}</label>
                                    <p
                                        class="tw-text-xs tw-text-gray-500 tw-mb-2"
                                    >
                                        You can create the account with
                                        <strong>Email Address</strong> as
                                        another option.
                                    </p>
                                    <div class="tw-relative">
                                        <div
                                            class="tw-absolute tw-top-[50%] tw-translate-y-[-50%] tw-left-3 tw-text-black"
                                        >
                                            <Select2
                                                v-model="
                                                    form.selected_country_code
                                                "
                                                :options="
                                                    $page.props
                                                        .country_dial_codes
                                                        .codes
                                                "
                                                :settings="{
                                                    templateSelection:
                                                        selectedFormat,
                                                    dropdownParent:
                                                        '#registerFormModal .modal-content',
                                                }"
                                                @change="myChangeEvent($event)"
                                                @select="mySelectEvent($event)"
                                                id="registerPhoneInput"
                                            />
                                        </div>
                                        <input
                                            type="text"
                                            name="phone"
                                            class="form-control tw-py-3 tw-border-none tw-bg-slate-100 tw-rounded-lg reg-phone-number-input"
                                            placeholder="Enter phone number"
                                            @keypress="inputValidate"
                                            @focus="
                                                input_errors.phone = '';
                                                show_switch = false;
                                            "
                                            @focusout="show_switch = true"
                                            v-model="form.phone"
                                        />
                                        <span
                                            v-if="show_switch"
                                            @click="changeLoginType('email')"
                                            class="tw-cursor-pointer tw-text-black/50 hover:tw-text-black tw-absolute tw-top-[50%] tw-translate-y-[-50%] tw-bg-white tw-px-3 tw-py-1 tw-rounded-lg tw-right-[10px] tw-text-black"
                                        >
                                            <i
                                                class="fas fa-angle-right tw-text-sm"
                                            ></i>
                                            <i
                                                class="fas fa-envelope tw-text-sm"
                                            ></i>
                                        </span>
                                    </div>
                                    <span
                                        class="tw-text-sm tw-text-red-600"
                                        v-if="input_errors.phone"
                                        v-text="input_errors.phone[0]"
                                    ></span>
                                </div>
                                <div
                                    v-show="form.register_type == 'email'"
                                    class="form-group"
                                >
                                    <label class="form-label tw-mb-0"
                                        >{{ __("chat.email_address") }}
                                    </label>
                                    <p
                                        class="tw-text-xs tw-text-gray-500 tw-mb-2"
                                    >
                                        You can create the account with
                                        <strong>Phone Number</strong> as another
                                        option.
                                    </p>
                                    <div class="tw-relative">
                                        <input
                                            type="email"
                                            name="email"
                                            class="form-control tw-py-3 tw-border-none tw-bg-slate-100 tw-rounded-lg"
                                            placeholder="Enter email address"
                                            @focus="
                                                input_errors.email = '';
                                                show_switch = false;
                                            "
                                            @focusout="show_switch = true"
                                            v-model="form.email"
                                        />
                                        <span
                                            v-if="show_switch"
                                            @click="changeLoginType('phone')"
                                            class="tw-cursor-pointer tw-text-black/50 hover:tw-text-black tw-absolute tw-top-[50%] tw-translate-y-[-50%] tw-bg-white tw-px-3 tw-py-1 tw-rounded-lg tw-right-[10px] tw-text-black"
                                        >
                                            <i
                                                class="fas fa-angle-right tw-text-sm"
                                            ></i>
                                            <i
                                                class="fas fa-phone tw-text-sm"
                                            ></i>
                                        </span>
                                    </div>
                                    <span
                                        class="tw-text-sm tw-text-red-600"
                                        v-if="input_errors.email"
                                        v-text="input_errors.email[0]"
                                    ></span>
                                </div>
                            </div>
                            <div class="col-md-12 tw-mb-3">
                                <div class="form-group">
                                    <label class="form-label tw-mb-1">{{
                                        __("chat.password")
                                    }}</label>
                                    <div class="tw-relative">
                                        <input
                                            name="password"
                                            :type="
                                                show_password
                                                    ? 'text'
                                                    : 'password'
                                            "
                                            v-model="form.password"
                                            @focus="input_errors.password = ''"
                                            class="form-control tw-py-3 tw-border-none tw-bg-slate-100 tw-rounded-lg"
                                            placeholder="Enter password"
                                        />
                                        <span
                                            v-if="form.password.length"
                                            @click="
                                                show_password = !show_password
                                            "
                                            class="tw-absolute tw-cursor-pointer tw-top-[50%] tw-text-slate-500 tw-translate-y-[-50%] tw-right-4"
                                            ><i
                                                v-if="show_password"
                                                class="fas fa-eye-slash"
                                            ></i>
                                            <i v-else class="far fa-eye"></i
                                        ></span>
                                    </div>
                                    <span
                                        class="tw-text-red-500 tw-text-xs"
                                        v-if="input_errors.password"
                                        v-text="input_errors.password[0]"
                                    ></span>
                                </div>
                            </div>
                            <div class="col-md-12 tw-mb-4">
                                <div class="form-group">
                                    <label class="form-label tw-mb-1"
                                        >{{ __("chat.confirm_password") }}
                                    </label>
                                    <div class="tw-relative">
                                        <input
                                            name="password_confirmation"
                                            :type="
                                                show_password_confirmation
                                                    ? 'text'
                                                    : 'password'
                                            "
                                            v-model="form.password_confirmation"
                                            @focus="
                                                input_errors.password_confirmation =
                                                    ''
                                            "
                                            class="form-control tw-py-3 tw-border-none tw-bg-slate-100 tw-rounded-lg"
                                            placeholder="Enter confirm password"
                                        />
                                        <span
                                            v-if="
                                                form.password_confirmation
                                                    .length
                                            "
                                            @click="
                                                show_password_confirmation =
                                                    !show_password_confirmation
                                            "
                                            class="tw-absolute tw-cursor-pointer tw-top-[50%] tw-text-slate-500 tw-translate-y-[-50%] tw-right-4"
                                            ><i
                                                v-if="
                                                    show_password_confirmation
                                                "
                                                class="fas fa-eye-slash"
                                            ></i>
                                            <i v-else class="far fa-eye"></i
                                        ></span>
                                    </div>
                                    <span
                                        class="tw-text-red-500 tw-text-xs"
                                        v-if="
                                            input_errors.password_confirmation
                                        "
                                        v-text="
                                            input_errors
                                                .password_confirmation[0]
                                        "
                                    ></span>
                                </div>
                            </div>
                            <div class="col-md-12 tw-mb-4">
                                <vue-recaptcha
                                    @verify="onCaptchaVerify"
                                    :sitekey="$page.props.recaptchav2_sitekey"
                                />
                                <span
                                    v-if="recaptcha_error"
                                    class="tw-text-red-500 tw-text-xs"
                                >
                                    {{
                                        translate(
                                            "Please confirm you are not a robot.",
                                            "သင်ကိုယ်တိုင်ဖြစ်ကြောင်း အတည်ပြုပါ။"
                                        )
                                    }}
                                </span>
                            </div>
                            <div class="col-md-12 tw-mb-3">
                                <p class="tw-m-0 tw-text-xs">
                                    {{
                                        translate(
                                            "By clicking Sign Up button, you agree to our",
                                            "အကောင့်ဖွင့်မည် ခလုပ်အားနှိပ်ခြင်းအားဖြင့် သင်သည် ကျွန်ုပ်တို့၏ "
                                        )
                                    }}
                                    <a
                                        href="/page/terms-conditions"
                                        target="_blank"
                                        >{{ __("chat.terms_conditions") }}</a
                                    >
                                    {{ __("chat.and") }}
                                    <a
                                        href="/page/privacy-policy"
                                        target="_blank"
                                        >{{ __("chat.privacy_policy") }} </a
                                    >{{
                                        translate(
                                            ".",
                                            "ကိုသဘောတူညီပြီး ဖြစ်ပါသည်"
                                        )
                                    }}
                                </p>
                            </div>
                            <div class="col-md-12">
                                <button
                                    type="submit"
                                    :disabled="registering"
                                    class="btn tw-w-full tw-p-2 tw-bg-main-color tw-text-white tw-rounded-lg"
                                >
                                    <BeatLoader
                                        v-if="registering"
                                        :loading="registering"
                                        color="white"
                                        size="7px"
                                    ></BeatLoader>
                                    <span v-else>{{ __("chat.sign_up") }}</span>
                                </button>
                            </div>
                        </div>

                        <van-divider>or</van-divider>

                        <ContinueWithGoogleButton />
                    </form>
                    <form autocomplete="off" @submit.prevent="onVerify" v-else>
                        <div>
                            <h5>Phone Number Verification</h5>
                            <button
                                type="button"
                                class="btn-close tw-opacity-100"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <hr class="tw-mb-4" />
                        <div class="row">
                            <div class="col-md-12 tw-mb-3">
                                <div class="tw-mb-8">
                                    <p class="tw-m-0">
                                        Please enter the OTP code to finish the
                                        registration process.
                                    </p>
                                    <p
                                        class="tw-mb-3"
                                        v-text="otp.otp_text"
                                    ></p>
                                    <p
                                        class="tw-m-0 tw-text-sm tw-text-slate-500"
                                    >
                                        If you don't received or expired OTP
                                        code -
                                        <span
                                            v-if="otp.otp_interval > 0"
                                            class="tw-text-main-color/60 tw-cursor-not-allowed"
                                            >Resend
                                            <span
                                                v-text="otp.countdown_text"
                                            ></span
                                        ></span>
                                        <span
                                            class="tw-text-main-color tw-cursor-pointer"
                                            v-if="otp.show_resent"
                                            @click="onReVerify"
                                            >Resend</span
                                        >
                                    </p>
                                </div>
                                <div class="tw-w-full">
                                    <div class="col-md-12 tw-mb-3">
                                        <div
                                            class="tw-leading-none tw-mb-3 tw-bg-red-50 dark:tw-bg-slate-700 tw-rounded-lg tw-p-2 tw-py-3 tw-flex tw-items-center"
                                            v-if="error_message.length > 0"
                                        >
                                            <i
                                                class="fas fa-exclamation-triangle tw-text-red-500 tw-text-md tw-ml-2 tw-mr-2"
                                            ></i>
                                            <span
                                                class="tw-text-sm tw-text-red-600"
                                                v-text="error_message"
                                            ></span>
                                        </div>
                                    </div>
                                    <input
                                        type="text"
                                        class="form-control tw-p-2 tw-text-center tw-tracking-[15px] placeholder:tw-tracking-normal"
                                        @keypress="otpInputValidate"
                                        v-model="otp.form.otp_code"
                                        placeholder="Enter OTP"
                                        @focus="input_errors.otp_code = ''"
                                    />
                                    <span
                                        class="tw-text-red-500 tw-text-xs"
                                        v-if="input_errors.otp_code"
                                        v-text="input_errors.otp_code[0]"
                                    ></span>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <button
                                    :disabled="verifying"
                                    class="btn tw-w-full tw-p-2 tw-rounded-lg tw-bg-main-color tw-text-white"
                                >
                                    <BeatLoader
                                        v-if="verifying"
                                        :loading="verifying"
                                        color="white"
                                        size="7px"
                                    ></BeatLoader>
                                    <span v-else>Verify</span>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Link } from "@inertiajs/vue2";
import { register, resendOtp, verify } from "@landing/Services/auth_service";
import { VueRecaptcha } from "vue-recaptcha";
import BeatLoader from "vue-spinner/src/BeatLoader.vue";
import ContinueWithGoogleButton from "@landing/Components/ContinueWithGoogleButton.vue";

export default {
    components: { VueRecaptcha, BeatLoader, Link, ContinueWithGoogleButton },
    data() {
        return {
            show_password: false,
            show_password_confirmation: false,
            show_form: false,
            registering: false,
            verifying: false,
            recaptcha_error: false,
            input_errors: {},
            error_message: "",
            phone_verification: false,
            show_switch: true,
            form: {
                "g-recaptcha-response": null,
                register_type: "email",
                name: "",
                phone: "",
                email: "",
                selected_dial_code: "",
                selected_country_code: "",
                password: "",
                password_confirmation: "",
            },
            otp: {
                form: {
                    type: "",
                    value: "",
                    otp_code: "",
                },
                otp_text: "",
                otp_interval: 0,
                countdown_text: "",
                intervalHandle: null,
                show_resent: false,
            },
        };
    },
    mounted() {
        let vm = this;
        let myModalEl = document.getElementById("registerFormModal");

        myModalEl.addEventListener("show.bs.modal", function (event) {
            vm.show_form = true;
            vm.form.selected_country_code =
                vm.$page.props.country_dial_codes.current.country_code;
            vm.form.selected_dial_code =
                vm.$page.props.country_dial_codes.current.dial_code;

            setTimeout(() => {
                vm.select2InputStyle(vm.form.selected_dial_code);
            }, 100);
        });

        myModalEl.addEventListener("hidden.bs.modal", function (event) {
            vm.show_form = false;
            vm.phone_verification = false;
            vm.otp.otp_interval = 0;
            vm.otp.show_resent = false;
            clearInterval(vm.intervalHandle);
        });
    },
    methods: {
        selectedFormat() {
            return this.form.selected_dial_code;
        },
        myChangeEvent(val) {
            this.select2InputStyle(val);
        },
        mySelectEvent({ id, text }) {
            const regex = /\((\+\d+)\)/;
            const match = text.match(regex);
            if (match && match.length > 1) {
                this.form.selected_dial_code = match[1];
            }

            this.select2InputStyle(this.form.selected_dial_code);
        },
        select2InputStyle(val) {
            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");
            context.font = "15px Arial";
            var metrics = context.measureText(val);
            let input = document.querySelector(".reg-phone-number-input");
            input.style.paddingLeft = Math.ceil(metrics.width) + 16 + "px";
        },
        onCaptchaVerify(token) {
            // Provide the token response to the form object.
            this.form["g-recaptcha-response"] = token;
            this.recaptcha_error = false;
        },
        inputValidate(evt) {
            var theEvent = evt || window.event;

            if (theEvent.code == "Enter") {
                return;
            }

            // Handle paste
            if (theEvent.type === "paste") {
                key = event.clipboardData.getData("text/plain");
            } else {
                // Handle key press
                var key = theEvent.keyCode || theEvent.which;
                key = String.fromCharCode(key);
            }
            var regex = /[0-9]|\./;
            if (!regex.test(key)) {
                theEvent.returnValue = false;
                if (theEvent.preventDefault) theEvent.preventDefault();
            }
        },
        otpInputValidate(evt) {
            var theEvent = evt || window.event;

            if (theEvent.code == "Enter") {
                return;
            }

            if (this.otp.form.otp_code.length >= 6) {
                theEvent.returnValue = false;
                if (theEvent.preventDefault) theEvent.preventDefault();
            }

            // Handle paste
            if (theEvent.type === "paste") {
                key = event.clipboardData.getData("text/plain");
            } else {
                // Handle key press
                var key = theEvent.keyCode || theEvent.which;
                key = String.fromCharCode(key);
            }
            var regex = /[0-9]|\./;
            if (!regex.test(key)) {
                theEvent.returnValue = false;
                if (theEvent.preventDefault) theEvent.preventDefault();
            }
        },
        tick() {
            // turn the seconds into mm:ss
            var min = Math.floor(this.otp.otp_interval / 60);
            var sec = this.otp.otp_interval - min * 60;

            //add a leading zero (as a string value) if seconds less than 10
            if (sec < 10) {
                sec = "0" + sec;
            }

            // concatenate with colon
            this.otp.countdown_text = "( " + min.toString() + ":" + sec + " )";

            // stop is down to zero
            if (this.otp.otp_interval === 0) {
                this.otp.show_resent = true;
                this.otp.countdown_text = "";
                clearInterval(this.otp.intervalHandle);
                return;
            }

            //subtract from seconds remaining
            this.otp.otp_interval--;
        },
        startCountDown() {
            if (this.otp.otp_interval > 0) {
                this.otp.show_resent = false;

                this.otp.intervalHandle = setInterval(() => {
                    this.tick();
                }, 1000);
            } else {
                this.otp.countdown_text = "";
                this.otp.show_resent = true;
            }
        },
        onSubmit() {
            this.registering = true;
            if (!this.form["g-recaptcha-response"]) {
                // Show error after submit.
                this.recaptcha_error = true;
                setTimeout(() => {
                    this.registering = false;
                }, 500);
            } else {
                register(this.form).then((data) => {
                    if (data.status == 500) {
                        this.error_message = data.data.message;
                    } else if (data.status == 422) {
                        this.error_message = "";
                        this.input_errors = data.data.errors;
                    } else if (data.status != 200 && data.status != 422) {
                        this.input_errors = {};
                        this.error_message = this.__("chat.something_wrong");
                    } else if (data.status == 200) {
                        this.input_errors = {};
                        this.error_message = "";
                        if (data.data.result == 1) {
                            this.otp.form.type = data.data.type;
                            this.otp.form.value = data.data.value;
                            this.otp.otp_text = data.data.otp_text;
                            this.otp.otp_interval = data.data.otp_interval;
                            this.phone_verification = true;
                            this.form.name = "";
                            this.form.phone = "";
                            this.form.password = "";
                            this.form.password_confirmation = "";
                            this.form["g-recaptcha-response"] = "";
                            this.startCountDown();
                        } else {
                            this.error_message = data.data.message;
                        }
                    }

                    setTimeout(() => {
                        this.registering = false;
                    }, 500);
                });
            }
        },
        onReVerify() {
            this.re_verifying = true;
            resendOtp({ phone: this.otp.form.value }).then((data) => {
                if (data.status == 422) {
                    this.error_message = "";
                    this.input_errors = data.data.errors;
                } else if (data.status != 200) {
                    this.error_message = "Oops! Something went wrong.";
                } else if (data.status == 200) {
                    this.error_message = "";
                    if (data.data.result == 1) {
                        this.otp.form.type = data.data.type;
                        this.otp.form.value = data.data.value;
                        this.otp.otp_text = data.data.otp_text;
                        this.otp.otp_interval = data.data.otp_interval;
                        this.startCountDown();
                        Vue.$toast.success("Successfully resend OTP code.");
                    } else {
                        this.error_message = data.data.message;
                    }
                }

                setTimeout(() => {
                    this.re_verifying = false;
                }, 500);
            });
        },
        onVerify() {
            this.verifying = true;
            verify(this.otp.form).then((data) => {
                if (data.status == 422) {
                    this.error_message = "";
                    this.input_errors = data.data.errors;
                } else if (data.status != 200 && data.status != 422) {
                    this.input_errors = {};
                    this.error_message = "Oops! Something went wrong.";
                } else if (data.status == 200) {
                    this.input_errors = {};
                    this.error_message = "";
                    if (data.data.result == 1) {
                        setTimeout(() => {
                            window.location.reload();
                        }, 500);
                    } else {
                        this.error_message = data.data.message;
                    }
                }

                setTimeout(() => {
                    this.verifying = false;
                }, 500);
            });
        },
        changeLoginType(val) {
            this.form.register_type = val;
        },
    },
};
</script>
